import React,{useEffect,useState} from 'react';
import { Grid,Box, Typography, Button,Tooltip } from '@mui/material';
import {IconButton} from '@mui/material';
// import {ReactComponent as StaffVector} from '../../StaticData/Vectors/staffVector.svg';
import DeleteIcon from '@mui/icons-material/Delete';
// import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { useDeleteStrategy} from '../../Hooks';
import { useSelector } from 'react-redux';
import EditIcon from '@mui/icons-material/Edit';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import DyLinearProgress from '../../../../components/GlobalComponents/DyLinearProgress/DyLinearProgress';
import DYToastMessage from '../../../../components/GlobalComponents/DyToastMessage/DYToastMessage';
import ProgressMeeting from '../../../Meeting/LComponents/ProgressMeeting/ProgressMeeting';

export const Strategy = (props:any) => {
    // const userId=useSelector((state:any)=>state.loign.userInfo.userId);
    const tenantId:string|null=useSelector((state:any)=>state.meetings.profileTenantId);
    // const userPhoneNumber=useSelector((state:any)=>state.loign.userPhoneNumber);
   
    const{mutate:deletePerson,data:deleteData,isSuccess:deletePerSuccess}=useDeleteStrategy();
    // const{mutate:deleteInvitedPerson,data:deleteInvitedData,isSuccess}=useDeleteInvitedPerson();
    // let{setPersonId}=props
    //     setShowToastMessage={setShowToastMessage}
    // setAddStaffState={setUserAsyncOpState}
    let{item,setPersonId,setShowEditModal,setPersonIdFDelete,actived,setDeleteState}=props;
    // console.log(item)
    let{name,id, score,scoreB,evaluationPercentageB,evaluationPercentage}=item;
    // const[imgSrc,setImgSrc]=useState<any>(null);
    const [showToastMessage, setShowToastMessage] = useState<boolean>(false);
    const [isSucces, SetIsSuccess] = useState<boolean>();
    const [tMessage, SetTMessage] = useState<string>();

const initialEditPerson=(perId:string|null)=>{
setShowEditModal(true)
setPersonId(item)
}



const initialDelete=(id:any)=>{
    let invitedPersonBody={
        deletedId:id,
        tenantId:tenantId
    }
    deletePerson(invitedPersonBody)
}

useEffect(() => {
  if (deleteData) {
    if (deleteData?.data.isSuccess) {
      // setSuccessAddObjective(isSuccess)
      setShowToastMessage(true);
      SetIsSuccess(true);
      SetTMessage(deleteData?.data.metaData.message);
    } else {
      setShowToastMessage(true);
      SetIsSuccess(false);
      SetTMessage(deleteData?.data.metaData.message);
      // setAddObjError(deleteData?.data);
    }
  }
}, [deleteData]);

// useEffect(() => {
  
//     if (deleteInvitedData) {
//         setShowToastMessage(true)
//         setDeleteState(deleteInvitedData?.data)
//     }


// }, [deleteInvitedData,isSuccess])

// useEffect(() => {
  
//     if (deletePersonData) {
//         setShowToastMessage(true)
//         setDeleteState(deletePersonData?.data)
//     }


// }, [isSuccess,deletePersonData])

// useEffect(() => {
    
//     if (item) {
//       setImgSrc(pictureBase64String)
//     }
//       }, [item])
 
      const [open, setOpen] = React.useState(false);
      const theme = useTheme();
      const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    
      const handleClickOpen = () => {
        setOpen(true);
      };
    
      const handleClos = () => {
        setOpen(false);
      };
    
      return (
        <Box
        width={'95%'}
        height={'100%'}
        marginY={2}
        borderRadius={3}
        boxShadow={4}
        padding={2}
        display="flex"
        alignItems="start"
      >
        <Grid container spacing={0}>
          <Grid item xs={2}>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
            </Box>
          </Grid>
          <Grid item xs={8} display="flex" justifyContent="center" alignItems="center">
            <Typography color="#001733" fontSize="15px" fontWeight={900} textAlign="center"
              sx={{
                fontSize: { xs: '12px', sm: '15px' } // در موبایل فونت کوچکتر، در وب فونت اصلی
              }}>
              {name}
            </Typography>
          </Grid>
      
          <Grid item xs={2} display="flex" justifyContent="flex-end" alignItems="center">
            <Tooltip title="ویرایش">
              <IconButton onClick={() => initialEditPerson(id)}>
                <EditIcon color="primary" />
              </IconButton>
            </Tooltip>
            <Tooltip title="حذف">
              <IconButton onClick={handleClickOpen}>
                <DeleteIcon color="error" />
              </IconButton>
            </Tooltip>
            <Dialog
              fullScreen={fullScreen}
              open={open}
              onClose={handleClos}
              aria-labelledby="responsive-dialog-title"
            >
              <DialogTitle id="responsive-dialog-title" fontWeight={600} fontSize={'17px'}>
                {"آیا از حذف اطمینان دارید؟"}
              </DialogTitle>
              <DialogActions>
                <Button autoFocus onClick={handleClos}>
                  <Typography color={'red'}> انصراف</Typography>
                </Button>
                <Button 
                 onClick={() => {
                  initialDelete(id);
                  handleClos();
                }}
                  autoFocus >
                  <Typography color={'#00387C'}> تایید</Typography>
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>
      
          {/** اهداف و نتایج کلیدی **/}
          <Grid item xs={12} display="flex" justifyContent="start" alignItems="center">
            <Grid item xs={4}>
              <Typography color="#001733" fontSize="13px" fontWeight={900} textAlign="left" m={0.5}   sx={{
    fontSize: { xs: '11px', sm: '13px' } // در موبایل فونت کوچکتر، در وب فونت اصلی
  }}>
                اهداف و نتایج کلیدی:
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Box width="100%" paddingY={0.5}>
                <DyLinearProgress value={score} />
              </Box>
            </Grid>
          </Grid>
      
          {/** شاخص‌های استراتژیک **/}
          <Grid item xs={12} display="flex" justifyContent="start" alignItems="center">
            <Grid item xs={4}>
              <Typography color="#001733" fontSize="13px"   sx={{
    fontSize: { xs: '11px', sm: '15px' } // در موبایل فونت کوچکتر، در وب فونت اصلی
  }} fontWeight={900} textAlign="left" m={0.5}>
                شاخص های استراتژیک:
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Box width="100%" paddingY={0.5}>
                <DyLinearProgress value={scoreB}/>
              </Box>
            </Grid>
          </Grid>
      
          <Tooltip title="درصد ارزیابی KR">
            <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <ProgressMeeting prog={evaluationPercentage} />
            </Box>
          </Tooltip>
            <Tooltip title="درصد ارزیابی BAU">
            <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <ProgressMeeting prog={evaluationPercentageB} />
            </Box>
          </Tooltip>

          {/** پروژه‌های کلان **/}
          {/* <Grid item xs={12} display="flex" justifyContent="start" alignItems="center">
            <Grid item xs={4}>
              <Typography color="#001733" fontSize="13px" fontWeight={900} textAlign="left" m={0.5}>
                پروژه های کلان:
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Box width="100%" paddingY={0.5}>
                <DyLinearProgress />
              </Box>
            </Grid>
          </Grid> */}
      
          {showToastMessage && (
          <DYToastMessage
            isSuccess={isSucces}
            message={tMessage}
            setShow={setShowToastMessage}
            show={showToastMessage}
          />
        )}
        </Grid>
      </Box>
      );
    };
    